/// <reference path="index.d.ts" />
import * as React from 'react';
import * as cookieInfo from '@alife/bc-cookie-info';
import doLog from '../../common/log';
import { Slider } from '@alifd/next';
import Card from './card';
import "./index.scss";

const { useMemo, useRef, useState, useEffect } = React;

export default function Index(props: { i18n: any; productId: string; companyId: string; }) {
  const { i18n, productId, companyId } = props;
  const [dataList, setData] = useState([]);
  const RecommendRef = useRef(null);
  const getList = async () => {
    const { getBuyerLocale } = cookieInfo;
    const result = await fetch(`/event/app/detailRecommendProducts/recommend.htm?detailId=${productId}&companyId=${companyId}&language=${getBuyerLocale()}&version=VB`).then(rst => rst.json());
    const getResourceForRecommend = {};
    if (result.code === 200 && result?.data?.length > 0) {

      result.data.forEach((i: RecommendType) => {
        getResourceForRecommend[i.strategy] = i.productList;
      })
      // 同步异步数据，减少多次请求
      window.getResourceForRecommend = getResourceForRecommend;
      if (getResourceForRecommend['you_may_like']?.length > 3) {
        setData(getResourceForRecommend['you_may_like']);
      }
    }
  }
  
  useMemo(() => {
    getList();
  }, [])

  if (!window.__getComponentInNode){
    const intersectionObserver = new IntersectionObserver(entries => {
      if (entries[0].intersectionRatio > 0) {
        doLog('/sc.details.recommend', `count=${dataList.length}`, 'EXP');
        intersectionObserver.disconnect();
      }
    });

    useMemo(() => {
      if (dataList.length > 0 && RecommendRef?.current) {
        intersectionObserver.observe(RecommendRef.current);
      }
      return () => {
        intersectionObserver.disconnect();
      }
    }, [dataList])
  }

  const settings = {
    arrowPosition: 'outer',
    infinite: false,
    dots: false,
    slidesToShow: 5,
    arrows: dataList.length > 5,
    slidesToScroll: 5,
    onChange: (currentSlide: any) => {
      doLog(
        '/details.index.relateProSlide',
        `slideNum=${currentSlide}`,
      );
    },
    lazyLoad: true,
  };

  return dataList.length > 0 ? (
    <div className="module-detailRecommendProducts you-may-like-layout" ref={RecommendRef}>
      <h3>{i18n["youmaylike.title3"]}</h3>
      <Slider {...settings as any} >
        {dataList.map((item, index) => <div className='recommend-card' key={item.id}><Card
          item={{
            promotionPrice: item.promotionPrice,
            sellPoints: item.sellPoints,
            viewsOrders: item.viewsOrders,
            detailUrl: item.detailUrl,
            discount: item.discount,
            mainImage: item.mainImage,
            title: item.title,
            price: item.priceText || item.price,
            realCtrParam: item.uiParam,
            clickParam: item.clickParam,
            rts: item.rts,
            moqText: item.moqText
          }}
          exposeDot="data-recommend-buy"
          index={index}
          i18n={i18n}
        /></div>)}
      </Slider>
    </div>
  ) : null
}
